import { Box, Button, DatePicker, Flex, Popover, TFNotifier, TFText, useDisclosure } from '@tf/ui';
import { fmt } from '@tf/utils';
import type React from 'react';
import { useEffect, useState } from 'react';
import { DateValue } from '@/components/shared/DateValue';
import { useUpdateCaseRequestDueDateMutation } from '@/core/api/caseRequests';

interface Props {
	caseRequestId: string;
	date?: string;
	isEditable: boolean;
}
export const DueDate: React.FC<Props> = ({ caseRequestId, date, isEditable }) => {
	const [selectedDate, setSelectedDate] = useState<Date>();

	useEffect(() => {
		if (date) {
			setSelectedDate(new Date(date));
		}
	}, [date]);

	const popover = useDisclosure();

	const updateCaseRequestDueDateMutation = useUpdateCaseRequestDueDateMutation();

	return (
		<Flex gap="0.5rem">
			<TFText fw="600">Due date:</TFText>
			<Popover withArrow opened={popover.isOpen} onClose={popover.close}>
				<Popover.Target>
					{isEditable ? (
						<DateValue style={{ color: '#155EEF' }} value={date} onClick={popover.toggle} defaultValue="Not set" />
					) : (
						<DateValue value={date} />
					)}
				</Popover.Target>
				<Popover.Dropdown>
					<DatePicker
						excludeDate={(date) => new Date() > date}
						locale="en"
						date={selectedDate}
						value={selectedDate}
						onDateChange={setSelectedDate}
						onChange={(value) => {
							setSelectedDate(value as Date);
						}}
					/>
					<Box sx={{ display: 'flex', marginTop: '.75rem' }}>
						<Button
							fullWidth
							variant="light"
							size="sm"
							mr=".75rem"
							onClick={() => {
								setSelectedDate(undefined);
								popover.close();
							}}
						>
							Cancel
						</Button>
						<Button
							fullWidth
							size="sm"
							disabled={!selectedDate}
							onClick={() => {
								if (selectedDate) {
									updateCaseRequestDueDateMutation.mutate(
										{
											caseRequestId,
											date: fmt.toDate(selectedDate, { preset: 'date_struct' }),
										},
										{
											onSuccess: popover.close,
											onError: () => {
												TFNotifier.error('Error while updating due date');
											},
										},
									);
								}
							}}
						>
							Set due date
						</Button>
					</Box>
				</Popover.Dropdown>
			</Popover>
		</Flex>
	);
};
